import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
const Forbidden = () => {
    const { t } = useTranslation()

    const backToHome = ()=>{
        window.location = "/"
    }
    
    return (
        <main>
            <div className={'wrapper-loading'}>
                <div className={'main-container-content forbidden'}>
                    <div className='errors'>
                        <img alt='forbidden' src={require('../../assets/img/forbidden.svg').default}/>
                        {/* <img alt='forbidden' src={require('../../assets/img/background-login-left-2.png').default}/> */}
                        <div className='title-error'>{t('noti.errorFobidden')}</div>
                        <Button onClick={backToHome}>{t('noti.returnHome')}</Button>
                    </div>
                </div>
            </div>
        </main>
    )
}

export default Forbidden